var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#A1A1A1",
    className: "app-icon"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3347 22.2525C21.6618 21.7252 22.7786 19.9131 24.6844 16.8194C26.5902 13.7257 27.5431 12.1671 27.5431 12.1446C27.5431 12.1146 27.5281 12.092 27.499 12.0779L21.4687 9.06842C21.1982 8.93326 20.7954 8.98999 20.599 9.31371L16.988 15.1866L21.3347 22.2525ZM13.7407 26.7125C14.2209 26.952 14.6545 26.7125 14.6545 26.1327C14.6495 20.2842 14.6578 17.0531 14.6624 15.2633V15.2632C14.668 13.1144 14.6682 13.0434 14.6334 13.0146L14.6297 13.0117C14.6271 13.0097 14.6242 13.0075 14.6212 13.0044L8.92543 10.151C8.28379 9.83065 8 10.0451 8 10.519V23.2233C8 23.3944 8.05493 23.5679 8.16228 23.7423C8.26964 23.9167 8.40113 24.041 8.55759 24.1152L13.7407 26.7125ZM20.9131 22.476L15.1597 13.2246L15.1301 19.6401L20.9131 22.476ZM27.8435 12.9306L28 25.0835C28 25.2695 27.9484 25.4197 27.8435 25.5348C27.7395 25.65 27.598 25.7075 27.4199 25.7075C27.2418 25.7075 27.0671 25.6592 26.8965 25.5624L21.8249 22.704L27.8435 12.9306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMedium);
export default __webpack_public_path__ + "static/media/footer_medium.b2b75363748bc7dc426a0f54df8f600f.svg";
export { ForwardRef as ReactComponent };